import React from 'react';
import './LightwayWordmark.css';

export default function LightwayWordmark({ variant = 'full', iconSrc, showSM = true }) {
  const compact = variant === 'compact';

  return (
    <div className={`lw-brand${compact ? ' lw-brand--compact' : ''}`}>
      {iconSrc && <img className="lw-brand__icon" src={iconSrc} alt="" />}
      <span className={`lw-wordmark${compact ? ' lw-wordmark--compact' : ''}`}>
        <span className="lw-wordmark__lead">Lightway</span>{' '}
        <span className="lw-wordmark__tail">Advocacy</span>
        {showSM && (
          <sup className="lw-wordmark__sm" aria-hidden="true">
            SM
          </sup>
        )}
      </span>
    </div>
  );
}
